export default __webpack_public_path__ + "static/media/hht1_ep16_timeline_q02_a.49a05ba6.png";